module.exports = __webpack_public_path__ + "img/create_campaign_success.45c5e762.gif";